(() => {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const animateIn = (targets, options = {}) => {
    const items = [...targets].filter(Boolean);
    if (!items.length || !window.anime || prefersReduced.matches) return;

    window.anime({
      targets: items,
      translateY: [options.y || 16, 0],
      rotate: [options.rotate || 0.25, 0],
      opacity: [0.98, 1],
      duration: options.duration || 700,
      delay: window.anime.stagger(options.stagger || 70),
      easing: 'easeOutExpo',
    });
  };

  const setupPanelReveal = () => {
    const panels = document.querySelectorAll(
      '.dolo-page-hero > *, .dolo-bio-hero__copy > *, .dolo-bio-card, .dolo-contact-hero > *, .dolo-contact-card, .dolo-page-tour, .dolo-page-card, body.template-product .product__media-wrapper, body.template-product .product__info-container, body.template-collection .card-wrapper, body.template-cart .cart__contents, body.template-cart .cart__footer, body.template-cart .cart__warnings'
    );
    if (!panels.length) return;

    if (!('IntersectionObserver' in window) || !window.anime || prefersReduced.matches) {
      panels.forEach((panel) => {
        panel.style.opacity = 1;
        panel.style.transform = 'none';
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          animateIn([entry.target]);
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px 14% 0px' }
    );

    panels.forEach((panel) => observer.observe(panel));
  };

  const setupDrift = () => {
    const shapes = document.querySelectorAll('.dolo-page-blob');
    if (!shapes.length || !window.anime || prefersReduced.matches) return;

    shapes.forEach((shape, index) => {
      window.anime({
        targets: shape,
        translateX: index % 2 === 0 ? ['-0.6rem', '1.1rem'] : ['0.8rem', '-1rem'],
        translateY: index % 2 === 0 ? ['0.8rem', '-1.2rem'] : ['-0.6rem', '1.4rem'],
        rotate: index % 2 === 0 ? [-10, 8] : [8, -12],
        duration: 3200 + index * 420,
        direction: 'alternate',
        easing: 'easeInOutSine',
        loop: true,
      });
    });
  };

  const setupNav = () => {
    const navItems = document.querySelectorAll('.dolo-world-nav__brand, .dolo-world-nav__links a, .dolo-world-nav__cart');
    animateIn(navItems, { y: -10, rotate: -0.2, duration: 560, stagger: 45 });
  };

  const init = () => {
    setupNav();
    setupPanelReveal();
    setupDrift();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
